export const GET_DOCUMNETS_REQUEST = 'GET_DOCUMNETS_REQUEST';
export const GET_DOCUMNETS_SUCCESS = 'GET_DOCUMNETS_SUCCESS';
export const GET_DOCUMNETS_FAILURE = 'GET_DOCUMNETS_FAILURE';